/* istanbul ignore file */

import { DeviceSearchResult } from "../devices/types";

export enum VideoReportingStates {
	PreSearch = "pre-search",
	Searching = "searching",
	ReviewingCameras = "reviewing",
	ProcessingReport = "processing",
	CompletedReport = "complete"
}

export interface VideoReportingState {
	videoReportingState: VideoReportingStates;
	videoReportingPrefs: {
		maxCameras: number;
		maxDistance: number;
		maxDuration: number;
		maxWorkers: number;
	};
	currentReport: {
		eventId: number | null;
		videoReportId: number | null;
		reviewsComplete: number;
		camerasComplete: number;
	};
	auditEndpoint: string | null;
	deviceEventRecords: DeviceEventRecords;
}

export interface VideoReportRequest {
	videoReportId: string | null;
	cameraSettings: {
		includeLinkedCameras: boolean;
		maxCameras: number | null;
		maxDistance: number | null;
		maxDuration: number | null;
	};
	search: DeviceSearchModel[];
}

export interface DeviceCamera {
	deviceID: number;
	title: string;
	successState: CameraRecordingState;
	cameraEventRecordId: number;
}

export interface DeviceSearchModel {
	deviceId: number | null;
	deviceTypeId: number | null;
	title: string;
	date: Date | null;

	maxDuration?: number | null;
	time?: string | null;
	searchResults?: DeviceSearchResult[] | null;
	cameras?: DeviceCamera[] | null;
}

export enum CameraRecordingState {
	Success = 1,
	Failure = 0,
	NoClip = 2
}

export interface CameraRecord {
	videoReportId: string | null;
	eventId: number | null;
	doorName: string | null;
	recordTime: string | null;
	durationRequested: number | null;
	cameraName: string | null;
	cameraId: number | null;
}

export interface DeviceEventRecords {
	[deviceId: number]: number;
}
